<template>
  <div class="app-container">
    <Navbar />

    <!-- 关键：给路由内容一个吃剩余空间的容器 -->
    <main class="page-main">
      <router-view />
    </main>

    <Footer />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'

export default {
  components: { Navbar, Footer },
  mounted() {
    document.title = this.$t('title')
  },
  watch: {
    '$i18n.locale'(val) {
      document.title = this.$t('title')
    }
  }
}
</script>

<style scoped>
/* 整体使用纵向 Flex，至少一屏高 */
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 关键：让主内容吃掉剩余空间，避免 footer 被撑离内容或跑上来 */
.page-main {
  flex: 1;
  min-height: 0;            /* 防止内部滚动计算异常 */
  display: flex;            /* 若你的页面内容本身也需要纵向排布，可保留 */
  flex-direction: column;
}

/* 避免最后一个块级元素的 margin-bottom 造成视觉空隙（可选但很实用） */
.page-main > *:last-child {
  margin-bottom: 0 !important;
}

/* 不必强行禁用 shrink；会影响在极端高度下的自适应 */
</style>
